document.addEventListener("DOMContentLoaded", () => {
  const colorButtons = document.querySelectorAll(".color-options__container button[data-color]");
  const legend = document.querySelector(".color-options__container legend");
  const variantInput = document.querySelector("input.product-variant-id");
  const productDataEl = document.querySelector("[data-product-json]");
  const productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;

  if (!productData) {
    console.warn("⚠️ No product JSON found. Exiting.");
    return;
  }

  // --- helper: update gallery + SKU + input + dispatch ----------------------
  const updateByVariantId = (variantId, updateUrl = true) => {
    const variant = productData.variants.find(v => v.id == variantId);
    if (!variant) return console.warn("⚠️ Variant not found:", variantId);

    // Choose correct image + alt depending on source
    let imageSrc = null;
    let imageAlt = null;

    if (variant.featured_image?.src) {
      imageSrc = variant.featured_image.src;
      imageAlt = variant.featured_image.alt || variant.title;
    } else if (variant.featured_media?.src) {
      imageSrc = variant.featured_media.src;
      imageAlt = variant.featured_media.alt || variant.title;
    } else {
      console.warn(`[variant] No featured image or media for variant ${variant.id}`);
      return;
    }

    // Update featured image
    const featuredImg = document.querySelector("[data-featured-media-container] img");
    const featuredAnchor = document.querySelector("[data-featured-media-container] a[data-fslightbox='pdp-gallery']");

    if (featuredImg) {
      featuredImg.src = imageSrc;
      featuredImg.alt = imageAlt;
    }

    if (featuredAnchor) {
      featuredAnchor.href = imageSrc;
    }

    // Update hidden input + SKU
    if (variantInput) variantInput.value = variant.id;
    const skuEl = document.querySelector("[data-product-sku]");
    if (skuEl) skuEl.textContent = variant.sku || "—";

    // Update URL (without reload)
    if (updateUrl) {
      const newUrl = `${window.location.pathname}?variant=${variant.id}`;
      window.history.replaceState({}, "", newUrl);
    }

    // Highlight matching thumbnail
    document.querySelectorAll("[data-thumbs-container] .thumb__container").forEach(t => t.classList.remove("active"));
    const matchingThumb = Array.from(document.querySelectorAll("[data-thumbs-container] img"))
      .find(img => img.src.includes(imageSrc.split("?")[0]));
    if (matchingThumb) {
      matchingThumb.closest(".thumb__container")?.classList.add("active");
    }

    // Dispatch global event
    document.dispatchEvent(
      new CustomEvent("variantSelected", {
        detail: {
          variantId: variant.id,
          variant: variant,
          image: imageSrc
        }
      })
    );
  };

  // --- initialize from URL param -------------------------------------------
  const urlParams = new URLSearchParams(window.location.search);
  const initialVariantId = parseInt(urlParams.get("variant"), 10);
  if (initialVariantId) {
    updateByVariantId(initialVariantId, false);
  }

  // --- listen for swatch clicks --------------------------------------------
  colorButtons.forEach(button => {
    button.addEventListener("click", () => {
      const variantId = button.dataset.variantId;
      const colorName = button.dataset.color;

      if (!variantId) return console.warn("⚠️ No variant ID found for swatch:", button);

      // Update UI legend + active state
      if (legend) legend.textContent = colorName;
      colorButtons.forEach(b => b.classList.remove("active"));
      button.classList.add("active");

      // Update gallery + URL + SKU + input + event
      updateByVariantId(variantId);
    });
  });
});
